import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTaskItem } from '../api/tasks';
import type { TaskFormValues } from '../types';
import { notification } from 'antd';

export function useUpdateTaskItem(id: string | null, onSuccess?: () => void) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: TaskFormValues) => {
      if (!id) throw new Error('Task ID is required');
      return updateTaskItem(id, data);
    },
    onSuccess: () => {
      notification.success({ message: 'Task updated successfully' });
      void queryClient.invalidateQueries({ queryKey: ['taskItems'] });
      void queryClient.invalidateQueries({ queryKey: ['taskItem', id] });
      void queryClient.invalidateQueries({ queryKey: ['task-dashboard'] });
      onSuccess?.();
    },
    onError: () => {
      notification.error({ message: 'Failed to update task' });
    },
  });
}
